// extracted by mini-css-extract-plugin
var _1 = "Menu_empty__c3061";
var _2 = "Menu_footer__e8e3f";
var _3 = "Menu_horizontal__cf770";
var _4 = "Menu_items__2e875";
var _5 = "Menu_root__3c9d0";
var _6 = "Menu_title__c1d0a";
export { _1 as "empty", _2 as "footer", _3 as "horizontal", _4 as "items", _5 as "root", _6 as "title" }
